module.exports = __webpack_public_path__ + "assets/img/LTC009.ee051801.png";